import React from 'react'
import i1 from './photolic/jevan.webp'
import './image.css'
const Jevan = () => {
  return (
    <div>
       <img src={i1} alt="" className='eimg'/>
    </div>
  )
}

export default Jevan
